import { render, staticRenderFns } from "./SendForAdminReview.vue?vue&type=template&id=3688a62e"
import script from "./SendForAdminReview.vue?vue&type=script&lang=js"
export * from "./SendForAdminReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports